import React from "react";
import { ClockCircleOutlined, CheckCircleOutlined, SafetyOutlined } from "@ant-design/icons";
import { Row, Col, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import {
  StyledAdvantages,
  AdvantageCard,
  IconWrapper,
  AdvantageContent,
  AdvantageTitle,
  AdvantageDescription,
  VisualizationMockup,
  MockupCard,
  MockupHeader,
  MockupInput,
  TimeSlotGrid,
  TimeSlot,
  MockupButton,
} from "./Advantages.styles";
import { SectionContentWrapper } from "../../styled";

export const Advantages: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const advantages = [
    {
      icon: <ClockCircleOutlined style={{ fontSize: 24, color: theme.colorPrimary }} />,
      title: t("home.advantages.saveTime.title"),
      description: t("home.advantages.saveTime.description"),
    },
    {
      icon: <CheckCircleOutlined style={{ fontSize: 24, color: theme.colorPrimary }} />,
      title: t("home.advantages.pricing.title"),
      description: t("home.advantages.pricing.description"),
    },
    {
      icon: <SafetyOutlined style={{ fontSize: 24, color: theme.colorPrimary }} />,
      title: t("home.advantages.reviews.title"),
      description: t("home.advantages.reviews.description"),
    },
  ];

  return (
    <StyledAdvantages>
      <SectionContentWrapper>
        <Row gutter={[48, 48]} align="middle">
          <Col xs={24} lg={12}>
            <Typography.Title level={2} style={{ fontWeight: 700, lineHeight: 1.2 }}>
              {t("home.advantages.title")}
            </Typography.Title>

            <Space direction="vertical" size={24} style={{ width: "100%", marginTop: 32 }}>
              {advantages.map((advantage, index) => (
                <AdvantageCard key={index}>
                  <IconWrapper>{advantage.icon}</IconWrapper>
                  <AdvantageContent>
                    <AdvantageTitle>{advantage.title}</AdvantageTitle>
                    <AdvantageDescription>{advantage.description}</AdvantageDescription>
                  </AdvantageContent>
                </AdvantageCard>
              ))}
            </Space>
          </Col>

          <Col xs={24} lg={12}>
            <VisualizationMockup>
              <MockupCard>
                <MockupHeader />
                <MockupInput />
                <TimeSlotGrid>
                  <TimeSlot $active>10:00</TimeSlot>
                  <TimeSlot />
                  <TimeSlot />
                </TimeSlotGrid>
                <MockupButton />
              </MockupCard>
            </VisualizationMockup>
          </Col>
        </Row>
      </SectionContentWrapper>
    </StyledAdvantages>
  );
};
